import { get, post } from "../helpers/api_helper";

const REWARDS_BASE_URL = "/shop/shop-reward";

const REWARDS_PRODUCTS_BASE_URL = "/shop/products";

export const getRewardsProductsService = (params, rejectWithValue) =>
  get(REWARDS_PRODUCTS_BASE_URL, { params }, rejectWithValue);

export const getRewardsService = (params, rejectWithValue) =>
  get(REWARDS_BASE_URL, { params }, rejectWithValue);

export const showRewardService = (id, rejectWithValue) =>
  get(`${REWARDS_BASE_URL}/${id}`, {}, rejectWithValue);

export const claimRewardService = (payload, rejectWithValue) =>
  post(`${REWARDS_BASE_URL}/claim`, payload, {}, rejectWithValue);
